export default __webpack_public_path__ + "static/media/green-inner.626d2154.svg";